import $ from "jquery";
import "../../jquery.scrollTo.min.js";
import { isEmpty } from "../helper/common.js";
import { showEmptyCartModal } from '../helper/showEmptyCartModal';
import { showHashMismatchModal } from "../helper/showHashMismatchModal";
import { getExeStatus, setExeStatus } from "../utils/exeStatus.js";

const CheckoutController = function (
    $scope,
    $http,
    $sce,
    $httpParamSerializerJQLike,
    AjaxHelper,
    CrossSell,
    UserControl,
    CartHelper,
    Watchers,
    Config,
    Cart,
    TicketFormatService,
    ShippingMethodService,
    Voucher,
    formatEventTimeFilter,
    $filter,
    Discount,
    $timeout,
    PaymentDataHelper
) {
    const exeStatus = getExeStatus();
    let personalizationStatusTimeout = null;

    Config.setConfig(checkoutConfig);
    Cart.setScope($scope);
    $scope.TicketFormatService = TicketFormatService;
    $scope.ShippingMethodService = ShippingMethodService;
    $scope.Cart = Cart;
    $scope.UserControl = UserControl;
    $scope.customer = UserControl.customer;
    $scope.CrossSell = CrossSell;
    $scope.Discount = Discount;
    $scope.Voucher = Voucher;
    $scope.informationModalOpen = false;
    $scope.projectName = checkoutConfig.projectname;

    const canonicalUrl = new URL(window.location.href);

    canonicalUrl.hash = '';

    $scope.canonicalUrl = canonicalUrl.href;
    $scope.showModal = function(id) {
        const element = document.getElementById(id);

        element.showModal();

        requestAnimationFrame(function () {
            const titleElement = element.querySelector(`#modal-title-${id}`);

            if (titleElement) {
                titleElement.focus();
            }
        });
    };

    $scope.closeModal = function(id) {
        const element = document.getElementById(id);

        element.close();
    };

    $scope.redeemVoucher = function () {
        Voucher.redeem($scope);
    };

    // Load Factories
    CrossSell.factory($scope);
    UserControl.factory($scope);
    CartHelper.factory($scope);
    AjaxHelper.factory($scope, $http, $httpParamSerializerJQLike);
    PaymentDataHelper.factory($scope);

    // Load url params
    var windowParams = decodeURI(window.location.search)
        .replace('?', '')
        .split('&')
        .map(function (param) { return param.split('='); });
    var params = {};
    windowParams.forEach(function (param) {
        params[ param[ 0 ] ] = param[ 1 ];
    });
    $scope.productAmountError = (params.error === 'productCountChanged');

    if ($scope.productAmountError) {
        setTimeout(function () {
            document.getElementById('productAmountChanged-modal-trigger').click();
        }, 100);
    }

    const iframePayment = document.getElementById('iframePayment');

    iframePayment.addEventListener('load', () => {
        // No src is loaded
        if (!iframePayment.getAttribute('src')) return;

        // Script access to a frame's content is subject to the same-origin policy.
        if (!iframePayment.contentWindow) return;

        if (iframePayment.contentWindow.document.body.innerHTML === '') {
            return $scope.displayError('no response from payment provider');
        }
    });

    $scope.onAttributeDateChange = function (id, identifier, nextFocus, focusToJump) {
        var day = $scope.personalizedTicketForm[ id ][ identifier + '_d' ];
        var month = $scope.personalizedTicketForm[ id ][ identifier + '_m' ];
        var year = $scope.personalizedTicketForm[ id ][ identifier + '_y' ];

        if (day && month && year) {
            $scope.personalizedTicketForm[ id ][ identifier ] = $filter('date')(
                day + '.' + month + '.' + year,
                'dd.MM.yyyy'
            );
        }
        if (nextFocus && focusToJump) {
            setTimeout(function () {
                document.getElementById(focusToJump).focus();
            }, 50); // time for validation
        }
    };

    /**
     * @param {Cart.PersonalizationAttributes} attributeElement
     * @param {string|number} itemId
     *
     * @return {boolean}
     */
    $scope.onAttributeChange = function (attributeElement, itemId) {
        if (attributeElement.type === 'tel') {
            var originalValue = $scope.personalizedTicketForm[ itemId ][ attributeElement.identifier ];
            var onlyNumbers = (originalValue).match(/[0-9]*/)[ 0 ];
            $scope.personalizedTicketForm[ itemId ][ attributeElement.identifier ] = onlyNumbers;
            return onlyNumbers === originalValue;
        }
        return true;
    };

    $scope.attributeDateSet = function (id, identifier, value) {
        if (!value) {
            return;
        }
        var date = value.split('.');
        var dateV = new Date(date[ 1 ] + '-' + date[ 0 ] + '-' + date[ 2 ]);

        $scope.personalizedTicketForm[ id ][ identifier + '_d' ] = $filter('date')(dateV, 'dd');
        $scope.personalizedTicketForm[ id ][ identifier + '_m' ] = $filter('date')(dateV, 'MM');
        $scope.personalizedTicketForm[ id ][ identifier + '_y' ] = $filter('date')(dateV, 'yyyy');

    };

    $scope.attributeDateValue = function (part, modelValue) {
        var date = modelValue.split('.');
        var dateV = new Date(date[ 2 ], date[ 1 ], date[ 0 ]);
        return $filter('date')(dateV, part);
    };

    $scope.initPurchase = function () {
        if (typeof ga !== "undefined") {
            // Tracking 1: Send initial call
            ga('set', 'page', 'newCo_Initial');
            ga('send', 'pageview');
        }

        if (typeof gtmHelper === 'object') {
            gtmHelper.pushCheckout(1, null);
            gtmHelper.pushAddToCart();
        }

        var splitPartOnHashParameter = window.location.href.indexOf('&hashMismatch=');
        if (splitPartOnHashParameter >= 0) {
            showHashMismatchModal(Object.keys(cartItems).length);
        }

        $scope.setCheckoutOptions(checkoutOptions, checkoutTranslations, translations);
        $scope.setDataFromFrontend();
        $scope.initDefaultVars();

        if (typeof customerData.email !== "undefined") {
            $scope.reservationMail = customerData.email;
        }

        UserControl.initCustomer(customerData);
        $scope.getContentData('countries');
        $scope.clearUnpermittedProducts();
        $scope.setDefaultOptions();
        $scope.pageInitialized = true;
        $scope.scrollTo('body');
        $scope.scrollCartToBottom();
        $scope.modalInformation = JSON.parse(modalInformation);
        $scope.modalInformationObject = {};

        if (Object.keys($scope.modalInformation).length > 0) {
            const eventinformationModal = document.getElementById('eventinformation_modal');

            setTimeout(function () {
                eventinformationModal.showModal();
                $scope.informationModalOpen = true;

                requestAnimationFrame(function () {
                    eventinformationModal.focus();
                });

            }, 100);

            eventinformationModal.addEventListener('close', function () {
                $scope.informationModalOpen = false;
            });
        }

        if (typeof $scope.eventAGB === 'object') {
            $scope.initAdditionalEventAGBRequires();
        }
    };

    $scope.setDefaultOptions = function (doValidate) {
        if ($scope.showSetNewPassword) {
            setTimeout(function () {
                document.getElementById('setnewpassword-modal-trigger').click();
            }, 100);
        }

        $scope.unsetContents(doValidate);
        $scope.showPaymentOptions = true;

        var showShippingOptions = Cart.setDefaultTicketFormat();

        if (!doValidate) {
            $scope.setShowTicketFormatOptions(!!(parseInt(checkoutConfig.expand_ticketformat_checkout)));
        } else {
            $scope.setShowTicketFormatOptions(false);
        }

        Cart.setDefaultShippingMethod();

        if (!showShippingOptions || doValidate) {
            $scope.setShowShippingOptions(false);
        } else {
            $scope.setShowShippingOptions(true);
        }

        if ($scope.formStatus.registerForPaymentMode || $scope.formStatus.loginForPaymentMode) {
            $scope.setDebitPayment();
        } else {
            Cart.setDefaultPaymentMethod();
        }
        $scope.checkCheckoutPossible();
    };

    $scope.ticketRequiresPersonalizationList = {};
    $scope.personalizedTicketForm = {};
    $scope.showTicketPersonalizeForm = false;
    $scope.siteLoadedInIFrame = siteLoadedInIFrame;
    $scope.amazonLoggedIn = amazonLoggedIn;
    $scope.amazonPayAvailable = false;
    $scope.amazonPayActive = false;
    $scope.amazonFoundUserAddress = false;
    $scope.insuranceListing = false;

    $scope.toggleInsuranceListing = function () {
        $scope.insuranceListing = !$scope.insuranceListing;
    };

    $scope.ticketRequiresPersonalization = function (ticket) {
        if (!$scope.ticketRequiresPersonalizationList.hasOwnProperty(ticket.eventid)) {
            $scope.ticketRequiresPersonalizationList[ ticket.eventid ] = {};
        }

        if (!$scope.ticketRequiresPersonalizationList[ ticket.eventid ].hasOwnProperty(ticket.id)) {
            $scope.ticketRequiresPersonalizationList[ ticket.eventid ][ 'seat-' + ticket.id ] = ticket;
            if (!$scope.personalizedTicketForm.hasOwnProperty(ticket.id) ||
                Object.keys($scope.personalizedTicketForm[ ticket.id ]).length <= 0) {
                $scope.personalizedTicketForm[ ticket.id ] = {};
                $scope.showTicketPersonalizeForm = true;

                if (ticket.eventpersonalizationattributes && ticket.eventpersonalizationattributes.length > 0) {
                    for (var a in ticket.eventpersonalizationattributes) {
                        if (ticket.eventpersonalizationattributes.hasOwnProperty(a) && typeof (a) !== 'function') {
                            if (typeof $scope.personalizedTicketForm[ ticket.id ].advancedPersonalization === 'undefined') {
                                $scope.personalizedTicketForm[ ticket.id ].advancedPersonalization = [];
                            }
                            var fallbackIdentifier = ticket.eventpersonalizationattributes[ a ].identifier;
                            if (typeof fallbackIdentifier === "undefined" || !fallbackIdentifier || fallbackIdentifier.length <= 0) {
                                fallbackIdentifier = ticket.eventpersonalizationattributes[ a ].name;
                            }
                            $scope.personalizedTicketForm[ ticket.id ][ fallbackIdentifier ] = ticket.advancedPersonalization[ fallbackIdentifier ];

                            if (ticket.eventpersonalizationattributes[ a ].type === 'number') {
                                $scope.personalizedTicketForm[ ticket.id ][ fallbackIdentifier ] = parseInt($scope.personalizedTicketForm[ ticket.id ][ fallbackIdentifier ]);
                            }
                        }
                    }
                } else {
                    $scope.personalizedTicketForm[ ticket.id ].firstname = ticket.ticketFirstName;
                    $scope.personalizedTicketForm[ ticket.id ].lastname = ticket.ticketLastName;
                }
            }
        }
    };

    $scope.initInformationModal = function (eventId) {
        $scope.modalInformationObject[ eventId ] = true;
    };

    $scope.toggleInformationModal = function (eventId) {
        $scope.modalInformationObject[ eventId ] = !$scope.modalInformationObject[ eventId ];
    };

    $scope.setDataFromFrontend = function () {
        $scope.cartItems = cartItems;
        $scope.cartItemsSummarized = cartItemsSummarized;
        $scope.eventAGB = checkoutEventAGB;
        $scope.fullyPersonalized = fullyPersonalized;
        $scope.personalizationEditMode = !fullyPersonalized;

        // If insurance is booked, show it in cart
        if (typeof $scope.cartItems === 'object') {
            for (var itemKey in $scope.cartItems) {
                if ($scope.cartItems.hasOwnProperty(itemKey)) {
                    if ($scope.cartItems[ itemKey ].type === 'event' && $scope.cartItems[ itemKey ].insured && typeof checkoutOptions[ 'insurance' ] === 'object') {
                        $scope.addInsuranceToCart();
                    }
                    if ($scope.cartItems[ itemKey ].type === 'discounttype') {
                        Discount.setItem($scope.cartItems[ itemKey ]);
                    }

                    if ($scope.cartItems[ itemKey ].type === 'event' && $scope.cartItems[ itemKey ].eventpersonalization) {
                        $scope.ticketRequiresPersonalization($scope.cartItems[ itemKey ]);
                    } else if ($scope.cartItems[ itemKey ].type === 'bundle' && $scope.cartItems[ itemKey ].hasOwnProperty('seats')) {
                        for (const bundleSeatKey in $scope.cartItems[itemKey]['seats']) {
                            if ($scope.cartItems[ itemKey ][ 'seats' ][ bundleSeatKey ].eventpersonalization) {
                                $scope.ticketRequiresPersonalization($scope.cartItems[ itemKey ][ 'seats' ][ bundleSeatKey ]);
                            }
                        }
                    }
                }

            }
        }
    };
    $scope.setIsDelCountryChanged = function (isDelCountryChanged) {
        $scope.isDelCountryChanged = isDelCountryChanged;
    };

    $scope.initDefaultVars = function () {
        $scope.cartSum = 0;
        $scope.countries = null;
        $scope.states = {};
        $scope.agbCheck = !!(parseInt(checkoutConfig.check_agb_checkout));
        $scope.newsletterCheck = false;
        $scope.priceOptionEdit = {};
        $scope.insuranceInCart = false;
        $scope.insuranceLiveRegionMessage = '';
        $scope.pendingInsuranceLiveRegionMessage = '';
        $scope.priceOptionLiveRegionMessage = '';
        $scope.discountAppliedLiveMessage = '';
        $scope.setDiscountAppliedLiveMessage = function (msg) { $scope.discountAppliedLiveMessage = msg; };
        $scope.clearDiscountAppliedLiveMessage = function () { $scope.discountAppliedLiveMessage = ''; };
        $scope.setShowTicketFormatOptions(!!(parseInt(checkoutConfig.expand_ticketformat_checkout)));
        $scope.showShippingOptions = false;
        $scope.checkoutPossible = false;
        $scope.cartSumError = false;
        $scope.paymentDataValid = false;
        $scope.additionalEventAGBCheck = {};
        if (typeof $scope.ajaxExecCnt == "undefined") {
            $scope.ajaxExecCnt = 0;
        }
        $scope.confirmDelete = null;
        $scope.editEmail = 0;
        $scope.showVoucherForm = false;
        $scope.numberOfShippingOptions = ShippingMethodService.methods.length;
        Voucher.resetItem();
        $scope.buyingVoucher = false; // Todo: Check this
        $scope.onlyVoucherInCart = false;
        //Todo: Backend Functionality
        $scope.showSetNewPassword = false;
        $scope.showAddressValidationWarning = false;
        $scope.allowed_modes = checkoutConfig.allowed_modes.split(",");
        $scope.templateCalculatedHash = false;
        $scope.checkBuyingVoucher();
        $scope.checkUsingVoucher();
        $scope.checkInsuranceInCart();
        $scope.checkIfTicketsInCart();


        $scope.hasGiftWrapper = false;
        $scope.onlyGiftWrapperInBasket = true;
        $scope.checkIfOnlyGiftWrapperIsInCart();
        if (typeof reservationLoaded !== "undefined") {
            $scope.reservationLoaded = !!reservationLoaded;
        } else {
            $scope.reservationLoaded = false;
        }

        // Accessible with showDebugLog() in console
        $scope.debugLog = [];

        $scope.formStatus = UserControl.formStatus;

        $scope.confirmStatus = {
            'address': false,
            'creditcard': false,
            'debit': false,
            'login': false,
            'payment': false,
            'shipping': false,
            'ticketformat': false,
            'agb': false,
            'newsletter': false,
            'fullyPersonalized': false,
            'tried': false // Indicates if the user has tried to complete the checkout
        };

        $scope.creditCard = {};
        $scope.debit = {};
        $scope.personalizationStatusMessage = '';
        $scope.personalizationStatusClass = '';
        $scope.personalizationStatusSuccessLiveMessage = '';
        $scope.personalizationStatusErrorLiveMessage = '';

        $scope.pageInitialized = false;
        $scope.setIsDelCountryChanged(0);
        Watchers.factory($scope);
    };

    $scope.clearPersonalizationStatus = function () {
        if (personalizationStatusTimeout) {
            $timeout.cancel(personalizationStatusTimeout);
            personalizationStatusTimeout = null;
        }

        $scope.personalizationStatusMessage = '';
        $scope.personalizationStatusClass = '';
        $scope.personalizationStatusSuccessLiveMessage = '';
        $scope.personalizationStatusErrorLiveMessage = '';
    };

    $scope.showPersonalizationStatus = function (message, isError) {
        $scope.clearPersonalizationStatus();
        $scope.personalizationStatusMessage = message;
        $scope.personalizationStatusClass = isError ? 'notFullyPersonalized' : 'fullyPersonalized';

        $timeout(function () {
            if (isError) {
                $scope.personalizationStatusErrorLiveMessage = message;
            } else {
                $scope.personalizationStatusSuccessLiveMessage = message;
            }
        }, 0);

        personalizationStatusTimeout = $timeout(function () {
            $scope.personalizationStatusMessage = '';
            $scope.personalizationStatusClass = '';
        }, 3000);
    };

    $scope.getPersonalizationStatusMessage = function (messageType) {
        var personalizationForm = document.getElementById('form-personalization');

        if (!personalizationForm) {
            return messageType === 'error' ? 'Nicht erfolgreich gespeichert' : 'Erfolgreich gespeichert';
        }

        return messageType === 'error'
            ? personalizationForm.getAttribute('data-error-message') || 'Nicht erfolgreich gespeichert'
            : personalizationForm.getAttribute('data-success-message') || 'Erfolgreich gespeichert';
    };

    $scope.initAdditionalEventAGBRequires = function () {
        for (var index in $scope.eventAGB) {
            if ($scope.eventAGB.hasOwnProperty(index)) {
                $scope.additionalEventAGBCheck[ index ] = false;
            }
        }
    };

    $scope.checkIfIsValidMode = function (paramMode) {
        return $scope.allowed_modes.indexOf(paramMode) >= 0;
    };

    $scope.initCustomer = function () {
        // Set Different Delivery Address
        $scope.customer.diffDeliveryAddress = !$scope.getCopyinv();

        // Check if customer is logged in
        $scope.formStatus.userLoggedIn = customerData.id;

        if (typeof customerData.email !== "undefined") {
            $scope.reservationMail = customerData.email;
        }

        if (typeof prefilledReservationEmail !== "undefined") {
            customerData.email = prefilledReservationEmail;
        }

    };

    $scope.setShowShippingOptions = function (value) {
        $scope.showShippingOptions = value;
        if ($scope.pageInitialized && value && Cart.shippingMethod && !$scope.pendingFocusAfterLogin) {
            $timeout(function () {
                var el = document.getElementById('chk-v-' + Cart.shippingMethod.id);
                if (el) {
                    el.focus();
                }
            });
        }
    };
    $scope.setShowTicketFormatOptions = function (value) {
        $scope.showTicketFormatOptions = value;
        if ($scope.pageInitialized && value && Cart.ticketFormat && !$scope.pendingFocusAfterLogin) {
            $timeout(function () {
                var el = document.getElementById('chk-tf-' + Cart.ticketFormat.ticketformattype);
                if (el) {
                    el.focus();
                }
            });
        }
    };

    $scope.scrollTo = function (sel) {
        $(function () {
            sel = $(sel);
            $(window).scrollTo(sel, 300, { 'offset': -120 });
        });
    };

    $scope.scrollToNextFrom = function (sel) {
        setTimeout(function () {
            $(function () {
                sel = $(sel);
                sel = sel.first().next();
                $(window).scrollTo(sel, 300, { 'offset': -100 });
            });
        }, 100);
    };

    $scope.scrollCartToBottom = function () {
        setTimeout(function () {
            $('.cart-cartItems').scrollTo("max", 300);
        }, 150);
    };

    $scope.setCheckoutOptions = function (checkoutOptions, checkoutTranslations, translations) {
        if (typeof $scope.translations === 'undefined') {
            $scope.translations = checkoutTranslations;
        } else if (typeof checkoutTranslations !== 'undefined') {
            for (var index in checkoutTranslations) {
                if (checkoutTranslations.hasOwnProperty(index)) {
                    $scope.translations[ index ] = checkoutTranslations[ index ];
                }
            }
        }
        if (translations || !$scope.translations[ "custom" ]) {
            $scope.translations[ "custom" ] = translations;
        }
        if (checkoutOptions[ 'ticketFormats' ]) {
            TicketFormatService.setFormats(checkoutOptions[ 'ticketFormats' ]);
        }

        if (checkoutOptions[ 'shippingMethods' ]) {
            ShippingMethodService.setMethods(checkoutOptions[ 'shippingMethods' ]);
        }

        $scope.paymentMethods = [];

        if (checkoutOptions[ 'paymentMethods' ]) {
            $scope.paymentMethods = checkoutOptions[ 'paymentMethods' ];
        }

        for (const paymentMethodToCheck in $scope.paymentMethods) {
            if (!$scope.paymentMethods.hasOwnProperty(paymentMethodToCheck)) {
                continue;
            }

            switch ($scope.paymentMethods[paymentMethodToCheck].payment_additional_filter) {
                case 'amazonpay':
                    $scope.amazonPayAvailable = true;
                    break;

                case 'APPLEPAY':
                    if (!window.ApplePaySession) {
                        $scope.paymentMethods.splice(paymentMethodToCheck, 1);
                    }
                    break;

                default:
                    // Handle other cases or do nothing
                    break;
            }
        }

        // Get insurance offer from checkout options
        if (typeof checkoutOptions[ 'insurance' ] === 'object') {
            $scope.insuranceOffer = checkoutOptions[ 'insurance' ];
        } else {
            $scope.insuranceOffer = null;
        }
        if (Cart.ticketFormat) {
            var currentTicketFormat = TicketFormatService.getFromConfig(Cart.ticketFormat.id);
            if (currentTicketFormat) {
                Cart.setTicketFormat(currentTicketFormat, true);
            } else {
                $scope.unsetContents();
                Cart.setDefaultTicketFormat();
            }
        }

        CrossSell.setCrossSellProductsByCheckoutOptions(checkoutOptions);

        $scope.countTickets = checkoutOptions.countTickets;
        $scope.countProducts = checkoutOptions.countProducts;

    };

    $scope.unsetContents = function (doValidate) {
        var resValidateTicketFormat = false;
        var resValidateShippingMethod = false;
        var resValidatePaymentMethod = false;

        if (doValidate) {
            resValidateTicketFormat = TicketFormatService.validate(Cart.ticketFormat);
            resValidateShippingMethod = ShippingMethodService.validate(Cart.shippingMethod);
            resValidatePaymentMethod = Cart.validatePaymentMethod(Cart.paymentMethod);
        }

        if (!resValidateTicketFormat) {
            Cart.resetTicketFormat();
        }

        if (!resValidateShippingMethod) {
            Cart.resetShippingMethod();
        }

        if (!resValidatePaymentMethod) {
            Cart.resetPaymentMethod();
        }

        if (!resValidateTicketFormat || !resValidateShippingMethod || !resValidatePaymentMethod) {
            $scope.contentConfirm = false;
        }
    };

    $scope.formatItemDescription = function (item) {
        if (item.type !== "event") {
            return 0;
        }
        var desc = item.description.split(",");
        var newDesc = [];
        if (desc.length == 3 && item.pkName) {
            newDesc.push(item.pkName);
            newDesc.push(desc[ 0 ]);
            newDesc.push(desc[ 1 ] + ", " + desc[ 2 ]);
            desc = newDesc;
        } else if (desc.length == 2 && item.pkName) {
            newDesc.push(item.pkName);
            newDesc.push(desc[ 0 ]);
            newDesc.push(desc[ 1 ]);
            desc = newDesc;
        } else if (desc.length == 1 && item.pkName) {
            newDesc.push(item.pkName);
            newDesc.push(desc[ 0 ]);
            desc = newDesc;
        }
        return desc;
    };

    /**
     * @deprecated use filter formatEventTime instead
     * @see formatEventTime
     * @param item
     * @returns {number|void}
     */
    $scope.formatItemTime = function (item) {
        if (item.type !== "event") {
            return 0;
        }
        item.eventtime = formatEventTimeFilter(item.eventtime);
    };

    $scope.getStateNameByIso = function (isocode) {
        for (var key in $scope.states) {
            if (!$scope.states.hasOwnProperty(key)) continue;
            var states = $scope.states[ key ];
            for (var i = 0; i < states.length; i++) {
                if (states[ i ].isocode === isocode) return states[ i ].name;
            }
        }
        return undefined;
    };

    // Takes two lists of objects and updates the given attributes of each object if the lists have the same length
    // otherwise the first list (objects) is set to the second list (response)
    // returns if anything was modified
    $scope.updateObjectAttributesFromResponse = function (objects, response, attributes) {
        var modified = false;
        if (objects.length != response.length) {
            for (var i = 0; i < response.length; i++) {
                var r = response[ i ];
                objects[ i ] = r;
            }
            modified = true;
        }
        else {
            for (var i = 0; i < objects.length; i++) {
                var o = objects[ i ];
                var r = response[ i ];
                for (var j = 0; j < attributes.length; j++) {
                    var a = attributes[ j ];
                    if (!_.isEqual(o[ a ], r[ a ])) {
                        o[ a ] = r[ a ];
                        modified = true;
                    }
                }
            }
        }
        return modified;
    };

    $scope.isTicketPersonalizationFormValid = function () {
        var personalizationForm = document.getElementById('form-personalization');

        if (!personalizationForm || !$scope.personalizationEditMode) {
            return true;
        }

        var $parsley = (typeof $(personalizationForm).parsley === 'function')
            ? $
            : ((window.jQuery && typeof window.jQuery(personalizationForm).parsley === 'function') ? window.jQuery : null);

        if ($parsley) {
            $parsley(personalizationForm).parsley();
            const parsleyValid = $parsley(personalizationForm).parsley('validate') !== false;
            return parsleyValid;
        }

        return true;
    };

    $scope.updateTicketPersonalization = function () {
        if (!$scope.isTicketPersonalizationFormValid()) {
            return;
        }

        $scope.clearPersonalizationStatus();

        $scope.ajaxCall('purchase', 'personalizetickets', 'POST', $scope.personalizedTicketForm,
            function (response) {
                $scope.fullyPersonalized = response.fully_personalized;

                if (response.fully_personalized === true) {
                    $scope.personalizationEditMode = false;
                    $scope.showPersonalizationStatus($scope.getPersonalizationStatusMessage('success'), false);
                    $scope.checkCheckoutPossible();
                } else {
                    $scope.showPersonalizationStatus($scope.getPersonalizationStatusMessage('error'), true);
                }
            }
        );
    };

    $scope.activatePersonalizationEditMode = function () {
        $scope.clearPersonalizationStatus();
        $scope.personalizationEditMode = true;

        $timeout(function () {
            var personalizationForm = document.getElementById('form-personalization');

            if (!personalizationForm) {
                return;
            }

            var focusableFields = Array.from(
                personalizationForm.querySelectorAll('input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])')
            );

            var fieldToFocus = focusableFields.find(function (field) {
                return $(field).is(':visible') &&
                    (field.getAttribute('aria-invalid') === 'true' || field.classList.contains('ng-invalid'));
            }) || focusableFields.find(function (field) {
                return $(field).is(':visible');
            });

            if (fieldToFocus) {
                fieldToFocus.focus();
            }
        }, 0);
    };

    $scope.updateCheckoutOptions = function () {
        $scope.ajaxCall('purchase', 'checkoutoptions', 'POST', null,
            function (response) {
                if (response.checkout_options) {
                    $scope.setCheckoutOptions(JSON.parse(response.checkout_options));

                    $scope.checkBuyingVoucher();
                    $scope.setDefaultOptions();
                    $scope.updateCartSum();

                    if ($scope.pendingFocusAfterLogin) {
                        $scope.pendingFocusAfterLogin = false;
                        $timeout(function () {
                            var ids = ['changeAddressButton', 'changeAddressButtonGuest'];
                            for (var i = 0; i < ids.length; i++) {
                                var el = document.getElementById(ids[i]);
                                if (el && !el.closest('.ng-hide')) {
                                    el.focus();
                                    break;
                                }
                            }
                        });
                    }
                    if (typeof gtmCheckout !== 'undefined') {
                        gtmCheckout.genericEvents(true);
                    }

                }
            });
    };

    $scope.setPaymentMethod = function (item) {

        if (item.identifier === 'amazonpay') {
            $scope.amazonPayActive = true;
        } else {
            $scope.amazonPayActive = false;
        }
        $scope.Cart.paymentMethod = item;
        $scope.contentConfirm = null;
        $scope.scrollCartToBottom();

        if (!(item.id in exeStatus.paymentMethods)) {
            //execStatus 0-error, 1-success, 2-in progress
            exeStatus.paymentMethods[ item.id ] = null;
        }

        if (item.usenewpayment === 1) {
            $('a.proceedCheckoutRequest').attr('ng-click', $('a.proceedCheckoutRequest').attr('data-urlpayment'));
        } else {
            $('a.proceedCheckoutRequest').attr('ng-click', $('a.proceedCheckoutRequest').attr('data-urlpaymentold'));
        }

        if ($scope.Cart.paymentMethod.identifier === 'debit') {
            $scope.loadPaymentData();

            if (!$scope.checkIban()) {
                $scope.debit.editable = true;
            }

        }

        if (!exeStatus.paymentMethods[ item.id ]) {
            switch ($scope.Cart.paymentMethod.identifier) {
                case 'hdp_cc':
                case 'hdp_pp':
                case 'hdp_dd':
                case 'hdp_su':
                    exeStatus.paymentMethods[ item.id ] = 2;
                    $scope.checkoutPossible = false;
                    document.getElementById('btn-order-confirm').innerHTML = translations.hdp_please_wait;
                    $scope.ajaxCall('purchase', 'retrievepaymentform', 'POST', $scope.Cart.paymentMethod,
                        function (response) {
                            document.getElementById('btn-order-confirm').innerHTML = translations.order_confirm;
                            if (response) {
                                if (response.status && response.url) {
                                    exeStatus.paymentMethods[ item.id ] = 1;
                                    $scope.Cart.paymentMethod.formAction = response.url;
                                } else {
                                    exeStatus.paymentMethods[ item.id ] = 0;
                                    //Todo: Error USER.LOGIN is mandatory but not setted
                                    $scope.displayError(response.error);
                                }
                            } else {
                                exeStatus.paymentMethods[ item.id ] = 1;
                            }

                            $scope.checkCheckoutPossible();
                        },
                        function (error) {
                            document.getElementById('btn-order-confirm').innerHTML = translations.order_confirm;
                            exeStatus.paymentMethods[ item.id ] = 0;
                            $scope.displayError(error);
                            $scope.checkCheckoutPossible();
                        });
                    break;

                default:
                    exeStatus.paymentMethods[ item.id ] = 1;
                    $scope.checkCheckoutPossible();
            }
        } else {
            $scope.checkCheckoutPossible();
        }
        $scope.updateCartSum();

        if (typeof ga !== "undefined") {
            // Tracking A 2: User selects payment method
            ga('set', 'page', 'newCO_Payment');
            ga('send', 'pageview');
        }
    };

    $scope.getContentData = function (contentType) {
        if ($scope[ contentType ] === null) {
            if (contentType === 'countries' && typeof countries !== 'undefined') {
                $scope[ contentType ] = countries;
                UserControl.setDefaultCountry();
            } else {
                $scope.ajaxCall('contentdata', '', 'POST', { type: contentType }, function (response) {
                    if (response.length) {
                        $scope[ contentType ] = response;
                        countries = response;
                        UserControl.setDefaultCountry();
                    }
                    else {
                        $scope.displayError("empty response in getContentData");
                    }
                }, function (error) {
                    $scope.displayError(error);
                });
            }
        }
    };

    $scope.getStatesContentData = function (country) {
        if (country && typeof $scope.states[ country ] === 'undefined') {
            var contentType = 'states_' + country.toLowerCase();

            if (typeof allStatesByCountry !== 'undefined') {
                if (allStatesByCountry[ contentType ]) {
                    $scope.states[ country ] = allStatesByCountry[ contentType ];
                }

                if (typeof $scope.states[ country ] !== 'undefined') {
                    // Required hack
                    UserControl.setStatesOfCountry(country);
                }
            } else {
                $scope.ajaxCall('contentdata', '', 'POST', { type: contentType }, function (response) {
                    if (response.length) {
                        $scope.states[ country ] = response;
                        allStatesByCountry = response;
                    }

                    if (typeof $scope.states[ country ] !== 'undefined') {
                        // Required hack
                        UserControl.setStatesOfCountry(country);
                    }
                }, function (error) {
                    $scope.displayError(error);
                });
            }
        }
    };

    $scope.checkCheckoutPossible = function () {
        $scope.checkoutPossible = false;

        if (checkoutConfig.use_recaptcha == 1) {
            grecaptcha.ready(function () {
                grecaptcha.execute();
            });
        }
        if ($scope.Cart.paymentMethod && exeStatus.paymentMethods[ $scope.Cart.paymentMethod.id ] === 2) {
            return;
        }

        if (($scope.formStatus && ($scope.formStatus.userLoggedIn || $scope.formStatus.guestLoggedIn)) || ($scope.amazonLoggedIn && !$scope.siteLoadedInIFrame && $scope.amazonFoundUserAddress)) {
            $scope.confirmStatus.login = true;

        } else {
            $scope.confirmStatus.login = false;
        }

        if (($scope.Cart.paymentMethod !== null && $scope.Cart.paymentMethod !== false || ($scope.amazonLoggedIn && !$scope.siteLoadedInIFrame)) || $scope.cartSum <= 0) {
            $scope.confirmStatus.payment = true;

        } else {
            $scope.confirmStatus.payment = false;
        }

        if ((Cart.shippingMethod !== null || ($scope.amazonLoggedIn && !$scope.siteLoadedInIFrame)) && (TicketFormatService.formats.length || $scope.buyingVoucher || !$scope.onlyGiftWrapperInBasket)) {
            $scope.confirmStatus.shipping = true;
        }
        else {
            $scope.confirmStatus.shipping = false;
        }
        if (Cart.ticketFormat && Cart.ticketFormat.ticketformattype || (TicketFormatService.formats.length || $scope.buyingVoucher || !$scope.onlyGiftWrapperInBasket)) {
            $scope.confirmStatus.ticketformat = true;
        }
        else {
            $scope.confirmStatus.ticketformat = false;
        }
        if ($scope.agbCheck) {
            $scope.confirmStatus.agb = true;
        }
        else {
            $scope.confirmStatus.agb = false;
        }
        if ($scope.newsletterCheck) {
            $scope.confirmStatus.newsletter = true;
        }
        else {
            $scope.confirmStatus.newsletter = false;
        }
        if (($scope.formStatus && !$scope.formStatus.updateMode && ($scope.formStatus.userLoggedIn || $scope.formStatus.guestLoggedIn)) || ($scope.amazonLoggedIn && !$scope.siteLoadedInIFrame)) {
            $scope.confirmStatus.address = true;
        }
        else {
            $scope.confirmStatus.address = false;
        }
        if ($scope.Cart.paymentMethod && ($scope.Cart.paymentMethod.identifier === "cc" || $scope.Cart.paymentMethod.identifier === "hdp_cc")) {
            var formID = "register-form-cc";
            var formObj = document.getElementById(formID);
            var valid = formObj.checkValidity();
            $scope.confirmStatus.creditcard = valid;

        } else {
            $scope.confirmStatus.creditcard = true;
        }

        if ($scope.Cart.paymentMethod && ($scope.Cart.paymentMethod.identifier === 'debit')) {
            var valid = !$scope.debit.editable;

            if (!valid) {
                $scope.checkPaymentForm();
            }
            $scope.confirmStatus.debit = valid;
        } else {
            $scope.confirmStatus.debit = true;
        }

        $scope.confirmStatus.eventAGB = $scope.eventAgbsAllChecked;

        if ($scope.fullyPersonalized) {
            $scope.confirmStatus.fullyPersonalized = true;
        } else {
            $scope.confirmStatus.fullyPersonalized = false;
        }

        var s = $scope.confirmStatus;
        if (s.login && s.payment && s.shipping && s.agb && s.ticketformat && s.address && s.creditcard && s.fullyPersonalized && s.eventAGB && s.debit
            && (($scope.amazonLoggedIn && !$scope.siteLoadedInIFrame) || !$scope.amazonLoggedIn)) {
            $scope.checkoutPossible = true;
        }
        else {
            $scope.checkoutPossible = false;
        }

        // Block checkout if a cart pricing error exists (cartError).
        if ($scope.cartSumError) {
            $scope.checkoutPossible = false;
        }
    };

    $scope.eventAgbsAllChecked = true;

    $scope.checkAllEventAgb = function () {
        var allEventAgbsAreTrue = true;
        if ($scope.eventAGB && $scope.additionalEventAGBCheck && Object.keys($scope.eventAGB).length > 0 && Object.keys($scope.additionalEventAGBCheck).length > 0) {
            for (var eventAgb in $scope.additionalEventAGBCheck) {
                if ($scope.additionalEventAGBCheck.hasOwnProperty(eventAgb)) {
                    if (!$scope.additionalEventAGBCheck[ eventAgb ]) {
                        allEventAgbsAreTrue = false;
                        break;
                    }
                }
            }
        }

        $scope.eventAgbsAllChecked = allEventAgbsAreTrue;
        $scope.checkCheckoutPossible();
    };

    $scope.checkAndRemoveEventAGB = function (item) {
        if (!item.eventid) {
            return;
        }
        var eventIDList = [];
        for (var cartItem in $scope.cartItems) {
            eventIDList[ $scope.cartItems[ cartItem ].eventid ] = true;
        }

        if ($scope.eventAGB !== null && $scope.eventAGB.hasOwnProperty(item.eventid) && !eventIDList[ item.eventid ]) {
            delete $scope.eventAGB[ item.eventid ];
            delete $scope.additionalEventAGBCheck[ item.eventid ];
        }
        $scope.checkAllEventAgb();
        $scope.checkCheckoutPossible();
    };

    $scope.displayError = function (message) {
        $('#spinner').fadeOut();
        $('#wrapper').show();
        $scope.debugLog.push(message);
        var $errorContainer = $('#error-container');
        var defaultMessage = $errorContainer.find('span').html();

        $errorContainer.show();
        $errorContainer.find('span').html(message);
        setTimeout(function () {
            $errorContainer.hide();
            $errorContainer.find('span').html(defaultMessage);
        }, 10000);
        $scope.scrollTo('#error-container');
    };

    $scope.setCreditCardBrand = function () {
        var nr = $scope.creditCard.number;
        var id1 = String(nr).substring(0, 1);
        var id2 = String(nr).substring(0, 2);
        id1 = Number(id1);
        id2 = Number(id2);
        var brand = false;
        if (id1 == 4) {
            brand = "VISA";
        }
        else if ((id2 >= 22 && id2 <= 27) || (id2 >= 51 && id2 <= 55)) {
            brand = "MASTER";
        }
        $scope.creditCard.brand = brand;
    };

    $scope.setAmazonPayment = function () {
        $($scope.paymentMethods).each(function (key, item) {
            if (item.identifier === 'amazonpay' && $scope.amazonLoggedIn) {
                $scope.setPaymentMethod(item);
                angular.element('#payment').scope().setPaymentMethod(item);
                return false;
            }
        });
    };

    $scope.setDebitPayment = function () {
        $($scope.paymentMethods).each(function (key, item) {
            if (item.identifier === 'debit') {
                $scope.setPaymentMethod(item);
                angular.element('#payment').scope().setPaymentMethod(item);
                return false;
            }
        });
    };

    $scope.doConfirm = function () {
        // The id of the CreditCard Form (both hdp and normal cc) is id="register-form-cc"
        // The form is in the file inc_cc_form.html
        $scope.checkCheckoutPossible();
        $scope.confirmStatus.tried = true;
        if ($scope.cartSumError) {
            $scope.displayError(translations.undefined_error_try_again_later);
            return false;
        }

        if (!$scope.checkoutPossible) {
            if (!$scope.fullyPersonalized) {
                $scope.personalizationEditMode = true;

                $timeout(function () {
                    if (!$scope.isTicketPersonalizationFormValid()) {
                        $scope.showPersonalizationStatus($scope.getPersonalizationStatusMessage('error'), true);
                    }

                    const firstInvalid = document.querySelector('[aria-invalid="true"]');
                    if (firstInvalid) {
                        firstInvalid.focus();
                    }
                }, 0);
            } else {
                $timeout(function () {
                    const firstInvalid = document.querySelector('[aria-invalid="true"]');
                    if (firstInvalid) {
                        firstInvalid.focus();
                    }
                }, 0);
            }
        }

        if ($scope.checkoutPossible && $scope.ajaxExecCnt === 0) {
            var paymentMethod = $scope.Cart.paymentMethod;
            if (($scope.Cart.paymentMethod != null) && ($scope.Cart.paymentMethod.identifier == "hdp_cc" || $scope.Cart.paymentMethod.identifier == "cc")) {
                var ccvalid = $scope.validateCCForm();
                if (!ccvalid) {
                    return false;
                }
            }
            if ($scope.cartSum <= 0) {
                //free of charge or voucher fake paymentMethod
                paymentMethod = { id: -1, identifier: '-' };
            }

            switch (paymentMethod.identifier) {
                case 'hdp_pp':
                case 'hdp_cc':
                case 'hdp_dd':
                case 'hdp_su':
                    if (!$scope.Cart.paymentMethod.formAction) {
                        $scope.displayError('invalid response url');
                        return;
                    }
            }

            $scope.templateCalculatedHash = $('#templateCalculatedHash').val();

            var requestObject = {
                agbcheck: $scope.confirmStatus.agb,
                newslettercheck: $scope.confirmStatus.newsletter,
                ticketFormat: Cart.ticketFormat,
                shippingMethod: Cart.shippingMethod,
                templateCalculatedHash: $scope.templateCalculatedHash,
                paymentMethod: paymentMethod,
                totalSum: $scope.cartSum,
                accountValidationWarn: $scope.activeWarning
            };

            if (paymentMethod.identifier == 'debit') {
                requestObject.debitName = $scope.debit.name;
                requestObject.debitIban = $scope.debit.iban;
            }
            var checkoutPaymentSelector = $('.proceedCheckoutRequest');
            var textBeforeAjaxCall = $(checkoutPaymentSelector).text();

            var translationProceedingPayment = $(checkoutPaymentSelector).attr('data-proceeding');
            const translationConfirmPayment = $(checkoutPaymentSelector).attr('data-confirmtext');
            $(checkoutPaymentSelector).attr('disabled', 'disabled').addClass('inactive').text(translationProceedingPayment);

            var controllerActionToCall = 'confirm';
            if ($scope.Cart.paymentMethod && $scope.Cart.paymentMethod.usenewpayment && $scope.Cart.sum > 0) {
                controllerActionToCall = 'payment';
            }
            $scope.ajaxCall(controllerActionToCall, '', 'POST', requestObject, function (response) {
                $(checkoutPaymentSelector).removeAttr('disabled').removeClass('inactive').text(textBeforeAjaxCall);
                if (response.paymentResponseAPI) {
                    if (response.paymentResponseAPI.redirect) {
                        window.location = response.paymentResponseAPI.redirect;
                    } else if (response.paymentResponseAPI.RedirectUrl) {
                        window.location = response.paymentResponseAPI.RedirectUrl;
                    } else if (response.paymentResponseAPI.message
                        && response.paymentResponseAPI.amazonSellerID
                        && response.paymentResponseAPI.amazonClientID
                        && response.paymentResponseAPI.amazonOrderReferenceID) {
                        if (response.paymentResponseAPI.editMode) {
                            amazonPay.addShippingMethodWidget('addressBookWidgetDiv');
                        } else {
                            amazonPay.addShippingMethodWidgetByOrderReferenceReadOnly('addressBookWidgetDiv', response.paymentResponseAPI.amazonOrderReferenceID);
                        }
                        amazonPay.addPaymentMethodWidgetByOrderReference('walletWidgetDiv', response.paymentResponseAPI.amazonOrderReferenceID);
                        $scope.displayError(response.paymentResponseAPI.message);
                    } else if (response.paymentResponseAPI.message || response.paymentResponseAPI.ErrorMessage) {
                        $('#payment-modal').trigger('open.leanModal');
                        $scope.displayError(response.paymentResponseAPI.message || response.paymentResponseAPI.ErrorMessage);
                        $(checkoutPaymentSelector).attr('disabled', '').removeClass('inactive').text(translationConfirmPayment);
                    } else if (typeof response.paymentResponseAPI.Redirect !== 'undefined'
                        && response.paymentResponseAPI.Redirect.RedirectUrl) {
                        $('#iframePayment').attr('src', response.paymentResponseAPI.Redirect.RedirectUrl);
                        $('#payment-modal').on('close.leanModal', function () {
                            window.location = 'app.php?view=purchase&mode=29';
                        });
                        $('#payment-modal-trigger').click();
                    } else {
                        $('#iframePayment').attr('src', response.paymentResponseAPI.RedirectUrl);
                        $('#payment-modal').on('close.leanModal', function () {
                            window.location = 'app.php?view=purchase&mode=29';
                        });
                        $('#payment-modal-trigger').click();
                    }
                } else if (response.redirect) {
                    window.location = response.redirect;
                } else if (response.status) {
                    if (paymentMethod.identifier == "cc" || paymentMethod.identifier == "hdp_cc") {
                        var formName = 'register-form-cc';
                    } else {
                        var formName = 'register-form-' + paymentMethod.identifier;
                    }

                    if (document.getElementById(formName)) {
                        var formObj = document.getElementById(formName);

                        if (response.formAction) {
                            formObj.action = response.formAction;
                        } else if ($scope.Cart.paymentMethod.formAction) {
                            formObj.action = $scope.Cart.paymentMethod.formAction + response.formVars;
                        }

                        if (formObj.action) {
                            formObj.submit();
                        } else {
                            $scope.displayError('invalid response url');
                        }
                    }
                } else if (response.iFrameRender) {
                    $('#nonIframePaymentContent').html(response.iFrameRender);
                    $('#payment-modal-trigger').click();
                } else {
                    if (typeof response.error !== "undefined" && response.error.length > 0) {
                        $scope.displayError(response.error);
                    } else {
                        // Todo: Completed Orders can end here
                        $scope.displayError("no response status in doConfirm");
                    }
                }
            }, function (error) {
                $scope.displayError((typeof error === 'string') ? error : translations.undefined_error_try_again_later);
            });
        }
    };

    $scope.reservationBoxShow = false;

    $scope.collapseReservationBox = function () {
        return $scope.reservationBoxShow = false;
    };

    $scope.expandReservationBox = function () {
        return $scope.reservationBoxShow = true;
    };

    $scope.reservationSuccessBox = false;

    $scope.reservationMail = '';

    $scope.reservationFeedback = '';

    $scope.reservationButtonDisabled = false;

    $scope.reservationOnEventAllowed = true;

    $scope.reservationAllowed = false;

    $scope.reservationProceedCheck = function () {
        if (typeof allow_reservation !== 'undefined') {
            $scope.reservationAllowed = allow_reservation;
        }

        if (typeof $scope.cartItems === 'object') {
            for (var itemKey in $scope.cartItems) {
                if ($scope.reservationOnEventAllowed && $scope.cartItems.hasOwnProperty(itemKey)
                    && $scope.cartItems[ itemKey ].type === 'event' && !$scope.cartItems[ itemKey ].allowreservation) {
                    $scope.reservationOnEventAllowed = false;
                    break;
                }
            }
        }
    };

    $scope.proceedReservation = function () {
        if ($scope.reservationMail) {
            $scope.reservationButtonDisabled = true;

            $scope.ajaxCall('purchase', 'addreservation', 'POST', {
                userEmail: $scope.reservationMail
            }, function (response) {
                $scope.reservationButtonDisabled = false;
                if (response.status && response.status === true) {
                    $scope.reservationSuccessBox = response.status;
                } else if (response.message) {
                    $scope.reservationFeedback = response.message;
                    $('.reservation-feedback').fadeIn();

                    setTimeout(function () {
                        $('.reservation-feedback').fadeOut();
                    }, 3000);
                }
            }, function (error) {
                $scope.reservationFeedback = $('.reservation-feedback-error').html();
                $('.reservation-feedback').fadeIn();

                setTimeout(function () {
                    $('.reservation-feedback').fadeOut();
                }, 3000);
            });
        }
        return $scope.reservationSuccessBox;
    };

    $scope.toogleHtmlTicketFormats = function (amazonLoggedIn, show) {
        if (show !== false) {
            show = true;
        }
        var formStatus = ($scope.formStatus && ($scope.formStatus.userLoggedIn || $scope.formStatus.guestLoggedIn)) || amazonLoggedIn;
        var status = !$scope.onlyVoucherInCart && $scope.TicketFormatService.formats.length && $scope.ShippingMethodService.methods.length;
        return (show ? formStatus && status : !formStatus || status);
    };

    $scope.priceOptionItem = {};

    function focusPriceOptionEditButton(itemId, delay, silent) {
        $timeout(function () {
            const button = $('[id="priceOptionEdit[' + itemId + ']"]:visible')[0];
            if (button) {
                if (silent) {
                    const originalLabel = button.getAttribute('aria-label');
                    const originalDescribedBy = button.getAttribute('aria-describedby');
                    button.removeAttribute('aria-label');
                    button.removeAttribute('aria-describedby');
                    button.focus();
                    setTimeout(function () {
                        if (originalLabel !== null) {
                            button.setAttribute('aria-label', originalLabel);
                        }
                        if (originalDescribedBy !== null) {
                            button.setAttribute('aria-describedby', originalDescribedBy);
                        }
                    }, 200);
                } else {
                    button.focus();
                }
            }
        }, delay || 0);
    }

    function focusPriceOptionSelect(priceOptElement) {
        $timeout(function () {
            const selectEl = priceOptElement.filter(':visible').find('select')[0];
            if (selectEl) {
                selectEl.focus();
            }
        });
    }

    $scope.changePriceOption = function (item, action, key, givenID) {

        var priceOptElement = $('.priceOption' + item.id);

        if (!(key in exeStatus.priceOptions)) {
            //execStatus 0-error, 1-success, 2-in progress
            exeStatus.priceOptions[ key ] = null;
        }

        if (!(item.id in $scope.priceOptionItem)) {
            delete $scope.priceOptionItem[ item.id ];
        }

        switch (action) {
            case 'save':
                if (exeStatus.priceOptions[ key ]) {
                    const priceOptionChangeElement = document.getElementById('priceOptionChange[' + item.id + ']');

                    exeStatus.priceOptions[ key ] = 2;

                    if (priceOptionChangeElement.value !== item.priceoptionid || givenID !== item.priceoptionid) {
                        var newPriceOptionID = priceOptionChangeElement.value;
                        if (typeof givenID === "undefined" || givenID > 0) {
                            newPriceOptionID = parseInt(givenID);
                        }

                        $scope.ajaxCall('priceoption', 'save', 'POST', {
                            seatid: item.id,
                            newpriceoptionid: newPriceOptionID,
                            priceoptionid: item.priceoptionid
                        }, function (response) {
                            exeStatus.priceOptions[ key ] = 1;

                            if (response.status) {
                                priceOptElement.html(response.name);
                                item.priceoption = response.name;
                                $scope.priceOptionEdit[ item.id ] = false;

                                $scope.priceOptionLiveRegionMessage = '';
                                $timeout(function () {
                                    let message = translations.checkout_cart_price_option_saved + ': ' + response.name;
                                    if (response.seat && typeof response.seat.price !== 'undefined' && response.seat.price > 0) {
                                        message += ', ' + $filter('currency')(response.seat.price);
                                    }
                                    $scope.priceOptionLiveRegionMessage = message;
                                }, 0);

                                focusPriceOptionEditButton(item.id, 0, true);

                                var isBundleTicket = false;
                                if ($scope.cartItems[ key ].hasOwnProperty('seats')) {
                                    isBundleTicket = true;
                                }
                                var seatKey = null;
                                if (isBundleTicket) {
                                    // key is bundleKey, so find the seat-key
                                    for (var seatIndex in $scope.cartItems[ key ].seats) {
                                        if (!$scope.cartItems[ key ].seats.hasOwnProperty(seatIndex)) {
                                            continue;
                                        }
                                        if ($scope.cartItems[ key ].seats[ seatIndex ].id === item.id) {
                                            seatKey = seatIndex;
                                            break;
                                        }
                                    }

                                }
                                for (var field in response.seat) {
                                    if (response.seat.hasOwnProperty(field)) {
                                        if (isBundleTicket) {
                                            $scope.cartItems[ key ].seats[ seatKey ][ field ] = response.seat[ field ];
                                        } else {
                                            $scope.cartItems[ key ][ field ] = response.seat[ field ];
                                        }
                                    }

                                    if (typeof response.seat.price !== 'undefined' && response.seat.price > 0) {
                                        var eventId = item.eventid;
                                        if (isBundleTicket) {
                                            eventId = 'bundles-' + item.eventid;
                                        }
                                        $scope.cartItemsSummarized[ eventId ].price = $scope.cartItemsSummarized[ eventId ].price - item.price + response.seat.price;
                                    }
                                }


                                if (response.checkout_options) {
                                    $scope.setCheckoutOptions(angular.fromJson(response.checkout_options), angular.fromJson(response.checkout_translations));
                                }

                                if (response.discount) {
                                    Discount.setDiscount(response.discount, $scope);
                                }

                                $scope.updateTicketInsurance();
                                $scope.checkBuyingVoucher();
                                $scope.setDefaultOptions(true);
                                $scope.updateCartSum();

                            } else {
                                exeStatus.priceOptions[ key ] = 0;
                                $scope.displayError(response.error);
                            }
                        }, function (error) {
                            exeStatus.priceOptions[ key ] = 0;
                            $scope.displayError(error);
                        });
                    } else {
                        priceOptElement.html(item.priceoption);
                        exeStatus.priceOptions[ key ] = 1;
                        focusPriceOptionEditButton(item.id);
                    }
                }

                break;

            case 'cancel':
                $scope.priceOptionEdit[ item.id ] = false;
                priceOptElement.html(item.priceoption);
                focusPriceOptionEditButton(item.id);
                break;

            default:
                if (exeStatus.priceOptions[ key ] != 2) {
                    $scope.priceOptionItem[ item.id ] = item;
                    $scope.priceOptionItem[ item.id ].key = key;

                    $scope.ajaxCall('priceoption', '', 'POST', { seatid: item.id }, function (response) {
                        exeStatus.priceOptions[ key ] = 1;


                        if (response.length) {
                            $scope.priceOptionEdit[ item.id ] = true;
                            priceOptElement.html(response);
                            const select = priceOptElement.filter(':visible').find('select')[0];
                            if (select) {
                                const label = document.createElement('label');
                                const labelText = document.createElement('span');
                                labelText.className = 'sr-only';
                                labelText.textContent = translations.checkout_cart_option_select_label;
                                label.appendChild(labelText);
                                select.parentNode.insertBefore(label, select);
                                label.appendChild(select);
                            }
                            focusPriceOptionSelect(priceOptElement);
                        }
                    }, function (error) {
                        $scope.displayError(error);

                        exeStatus.priceOptions[ key ] = 0;

                    });
                }
        }
    };

    if ((typeof cartItems == 'object' && cartItems !== null) && (typeof checkoutOptions == 'object' && checkoutOptions !== null) && (typeof customerData == 'object' && customerData !== null)) {
        $scope.initPurchase();

        // Initialize current Cart Configuration
        if (cartConfig.ticketformatid && !$scope.Cart.ticketFormat) {
            const ticketFormat = TicketFormatService.getFromConfig(cartConfig.ticketformatid);
            if (ticketFormat) {
                $scope.Cart.ticketFormat = ticketFormat;
                $scope.scrollCartToBottom();
                Cart.setShippingVisibilityByTicketFormat(ticketFormat);
            }
        }
        if (cartConfig.shippingmethodid) {
            const sm = ShippingMethodService.getShippingMethodByID(cartConfig.shippingmethodid);
            if (sm) {
                $scope.Cart.setShippingMethod(sm);
            } else {
                Cart.resetShippingMethod(); // oder $scope.Cart.shippingMethod = null;
            }
        }

        // After restoring shipping method, re-validate shipping visibility for the current ticket format.
        // If the restored shipping method is not compatible/visible for the current ticket format, Cart will reset it.
        if ($scope.Cart.ticketFormat) {
            Cart.setShippingVisibilityByTicketFormat($scope.Cart.ticketFormat);
        }
        if (cartConfig.paymentmethodid) {
            const cartPaymentMethod = $scope.paymentMethods.filter((paymentMethod) => paymentMethod.id === parseInt(cartConfig.paymentmethodid));

            $scope.setPaymentMethod(cartPaymentMethod);
            angular.element('#payment').scope().setPaymentMethod(cartPaymentMethod);
        }

        $scope.updateCartSum();
        $scope.showClock = true;
    }
    else {
        showEmptyCartModal();
        $scope.showClock = false;
    }
    if (cartItems === null || isEmpty(cartItems)) {
        showEmptyCartModal();
        $scope.showClock = false;

        if (typeof ga !== "undefined") {
            // Tracking 2a: <- Ticket says 2a again? - Push up emptyBasket_deleted_items
            ga('set', 'page', 'newCO_emptyBasket_Deleted_Items');
            ga('send', 'pageview');
        }
    }

    if ((!wlec || !wlec.jsApi) && typeof YoutixJsApi === 'function') {
        if (!wlec) {
            wlec = {};
        }
        wlec.jsApi = new YoutixJsApi(wlec);
    }

    // Initialize current Cart Configuration (legacy fallback): do not override if already set above.
    if (cartConfig.shippingmethodid && !$scope.Cart.shippingMethod) {
        $scope.Cart.setShippingMethod(ShippingMethodService.getShippingMethodByID(cartConfig.shippingmethodid));
    }
    if (wlec && wlec.jsApi) {
        $timeout(function () {

            wlec.jsApi.fireEvent('ready');
        }, 0);
    }

    setExeStatus(exeStatus);
};

export default CheckoutController;
